type TranslateFn = (key: string, fallback: string) => string;

/** Validates password against all rules. Returns `true` if valid, or the first failing rule's message. */
export const validatePassword = (pwd: string, t: TranslateFn): string | true => {
  if (/\s/.test(pwd))
    return t("pages.setPassword.passwordNoSpaces", "Les espaces ne sont pas autorisés");
  if (pwd.length < 12) return t("pages.setPassword.passwordTooShort", "12 caractères minimum");
  if (!/[A-Z]/.test(pwd))
    return t("pages.setPassword.passwordNeedsUppercase", "1 majuscule requise");
  if (!/[a-z]/.test(pwd))
    return t("pages.setPassword.passwordNeedsLowercase", "1 minuscule requise");
  if (!/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(pwd))
    return t("pages.setPassword.passwordNeedsSpecialChar", "1 caractère spécial requis");
  return true;
};

/** Returns a strength rating assuming the password has already passed validatePassword. */
export const getPasswordStrength = (pwd: string, t: TranslateFn): "weak" | "medium" | "strong" => {
  const validation = validatePassword(pwd, t);
  if (validation !== true) return "weak";

  let score = 0;
  if (pwd.length >= 12) score++;
  if (pwd.length >= 16) score++;
  if (/[A-Z]/.test(pwd)) score++;
  if (/[a-z]/.test(pwd)) score++;
  if (/[0-9]/.test(pwd)) score++;
  if (/[!@#$%^&*()_+\-=[\]{}|;:,.<>?]/.test(pwd)) score++;

  if (score <= 3) return "weak";
  if (score <= 4) return "medium";
  return "strong";
};
